import { domReady } from 'utilities/dom';

domReady(() => {

	window.initFormValidation(true, 'form.lpForm');

});
